import { render } from "./MembersLandingView.vue?vue&type=template&id=24f2e8f6"
import script from "./MembersLandingView.vue?vue&type=script&lang=js"
export * from "./MembersLandingView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\luke\\Desktop\\membership_application\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__